<demo-section [name]="name" [src]="src" [componentContent]="componentContent">
  <p>Provides contextual feedback messages for typical user actions with the handful of available and flexible alert messages.</p>
  <p>The easiest way to add an alerts component to your app (will be added to the root module)</p>
  <pre class="prettyprint lang-bash prettyprinted"><span class="pln">ng add ngx</span><span class="pun">-</span><span class="pln">bootstrap </span> --component <span class="pln">alerts</span></pre>
  <docs-section [content]="componentContent"></docs-section>
</demo-section>
